(ns rlws.iot-cloud.frontend.assets.components
  (:require [goog.string :as gstr]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [rlws.iot-cloud.frontend.components :as components]
            [rlws.iot-cloud.frontend.data :as data]
            [rlws.iot-cloud.frontend.forms :as forms]
            [rlws.iot-cloud.frontend.navigation :as navigation]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [reitit.frontend.easy :as rfe]
            [rlws.iot-cloud.frontend.events :as events]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.site :as site]
            [goog.string :as gstring]
            [goog.string.format]))

(defn asset-status-icon
  [{:keys [state]}]
  (let [{:keys [image-path icon]} (data/asset-states state)]
    (if image-path
      [:img.width-sm.margin-right-xs {:src image-path}]
      [:i {:class ["fa" icon "text-lg" "margin-right-xs" "padding"
                   "color-primary-lighter" "padding-xxxxs"
                   "align-middle"]}])))

(defn asset-status
  [{:keys [title state] :as status}] 
  (case state 
    :ok [:span.connected-display [:img {:src "/img/icon-connected.svg"}] title]
    :warning [:span.warning-display [:img {:src "/img/icon-warning.svg"}] title]
    :cell-connection [:span.warning-display [:img {:src "/img/icon-warning.svg"}] title]
    :error [:span.disconnected-display [:img {:src "/img/icon-error.svg"}] title]
    [:span.disconnected-display [:img {:src "/img/icon-error.svg"}] "Disconnected"] ))

(defn scale-cell-data
  [{:keys [label details specs status image]}]
  [:div.scale-cell-data
   [:h2.scale-cell-data__title label]
   [:div.scale-cell-data-details__container
    (for [[k {:keys [value label unit]}] details
          :when value]
      ^{:key k}
      [:div.scale-cell-data__details
       [:p.scale-cell-data-details__label (str label ":")]
       [:p.scale-cell-data-details__value
        (if (and value unit)
          (str value " " unit)
          value)]])]
   (let [{:keys [title state]
          :or {title "Clear" state :ok}} (data/diagnostics status)
         {:keys [image-path icon]} (data/asset-states state)]
     [:div.scale-cell-data-state__container
      [:div
       [:div.scale-cell-data-state__label-group
        (if image-path
          [:img.width-sm.margin-right-xs {:src image-path}]
          [:i {:class ["fa" icon "text-lg" "margin-right-xs" "padding"
                       "color-primary-lighter" "padding-xxxxs"
                       "align-middle"]}])
        [:p.scale-cell-data-state__label.line-height-xs
         {:class (when (not= :ok status) "color-error")}
         title]]]])
   [:div.scale-cell-data-specs__container
    (for [[k {:keys [value label unit]}] specs]
      ^{:key k}
      [:div.scale-cell-data__specs
       [:p.scale-cell-data-specs__label label]
       [:p.scale-cell-data-specs__value
        (if (and value unit)
          (str value " " unit)
          value)]])]
   (when image
     [:div.scale-cell-data-img__container
      [:img {:src (:data image)}]])])

(defn cell-modal
  [data status] 
    [scale-cell-data
   {:label name
    :status status
    :image (:image data)
    :details {:full-load {:label "Percentage of Full Load"
                          :value (gstr/format "%.2f%" (:full-load-perc data))}
              :counts {:label "Raw A/D Counts"
                       :value (:counts data)}
              :voltage {:label "Raw A/D Voltage"
                        :value (gstr/format "%.2f" (:raw-mv data))
                        :unit "mV"}
              :drift {:label "Cell Drift"
                      :value (:cell-drift data)}
              :noise {:label "Cell Noise"
                      :value (:cell-noise data)}}
    :specs {:serial-number {:label "Serial Number"
                            :value (:serial-number data)}
            :model-name {:label "Model Name"
                         :value (:model data)}
            :capacity {:label "Capacity"
                       :value (:capacity data)
                       :unit "lbs"}
            :part-number {:label "Part Number"
                          :value (:part-number data)}
            :zero-value {:label "Zero Value"
                         :value (:zero-value data)}
            :factory-sensitivity {:label "Factory Sensitivity"
                                  :value (:factory-sensitivity data)
                                  :unit "mV"}
            :normalization-value {:label "Normalization Value"
                                  :value (:normalization-value data)}}}])

(defn scale-cell-box-static
  [{:keys [cell model sn] :as data}]
  [:div.box
   [:div.box__header.scale-cell-box__header
    [:div.box__name (str cell)]
    [:div.box__icon]]
   [:div.box__body
    [:div (str "Model: " model)]
    [:div.mobile-hidden
     (str "SN: " sn)]]])

(defn scale-cell-box
  [{:keys [id number raw-mv weight units status blank] :as data}] 
  (if blank
    [:div.box.box__empty]
    [:div.box
     {:on-click #(rf/dispatch [:modal {:show? true
                                       :title (str "Cell Number - " number)
                                       :state (when (not= :ok status) :red)
                                       :child [cell-modal data status]}])
      :class (case status
               :emulation "box-warning" 
               :ok "box"
               "box-error")}
     [:div.box__name (str "Cell " number)]
     [:div (case status
             :emulation "Emulated"
             (str (gstring/format "%.6f" raw-mv) " mV"))]]))

(defn scale-component-box
  [{:keys [label status status-label info]}]
  [:div.box
   [:div.box__header.scale-component-box__header
    (case status
      :ready [:<>
              [:div.box__name label]
              [:div.box__icon]]
      nil)]
   [:div.box__body
    [:div (str "Status: " status-label)]
    [:div (str "Information: " info)]]])

(defn online-offline-component
  [asset-id]
  (let [live-assets @(rf/subscribe [::sub/live-assets])]
    [:div 
     [:strong
      (if (get live-assets asset-id)
        [:div  {:style {:display "flex"
                        :flex-direction "column"
                        :align-content "center"
                        :justify-content "center"
                        :padding "20px"}} "Connecting" [:div.spinner.spinner-dark]]
        [:div {:style {:padding "20px" :font-size "20px"}}"Offline"])]]))

(defn scale-cells-subheader
  [{:keys [status asset inline?]}]
  (let [load-cells (:load-cells status)
        load-cells (if (= 3 (count load-cells))
                     (conj (vec load-cells) {:blank true})
                     load-cells)
        asset-id (:asset @(rf/subscribe [::sub/path-params]))]
    [:div.scale-cells-subheader__container
     {:class (when-not inline? "fixed")
      :style {:display :flex}}
     (if load-cells
       [:div {:style {:flex-direction :row}}
        [:div.scale-cell__container
         (for [load-cell (keep-indexed #(when (even? %1) %2) load-cells)]
           ^{:key load-cell}
           [scale-cell-box load-cell])]
        [:div.scale-cell__container.scale-cell__container--reverse
         (for [load-cell (keep-indexed #(when (odd? %1) %2) load-cells)]
           ^{:key load-cell}
           [scale-cell-box load-cell])]]
       [:div.padding-top-md
        [online-offline-component asset-id]])]))

(defn live-weight-subheader
  [{:keys [status asset]}]
  (if status
    (let [asset-id (:id asset)]
      [:div.live-weight-subheader__container
       [:div {:style {:width "30%" :height "100%" :padding "12px" :display "flex" :flex-direction "column"}}]
       [:div {:style {:width "70%" :display "flex" :justify-content "end"}}
        [:div.asset-live-group
         [:<>
          [:div.asset-live-weight
           [:div.live-weight__number (or (:gross-weight-display status) (:gross-weight status))]
           [:div.live-weight__unit (:gross-units status)]]]]]])
    [online-offline-component (:id asset)]))

(defn asset-component-picture
  [{:keys [src]}]
  [:div.asset-profile__image
   [:img {:src src}]])

(defn asset-image-component
  [name images]
  (if (seq images)
    [:div
     {:on-click #(rf/dispatch [:modal {:show? true
                                       :title (str name " Images")
                                       :child [components/image-gallery images]}])}
     [:div.asset__image
      [:img {:src (:url (first images))}]]
     [:p.image__caption (str "See All (" (count images) ")")]]
    [:div.asset__image
     [:img {:src "https://medifactia.com/wp-content/uploads/2018/01/placeholder.png"}]]))

(defn asset-profile-component
  [id {:asset/keys [name category location images company] :as values}]
  [:div.asset-profile.component-card
   [:div.asset-profile__head
    [:div [:h2 name]]
    [:div.head__icon
     {:on-click #(rf/dispatch [:modal {:show? true
                                       :title (str "Edit " name)
                                       :child [forms/form-component
                                               (forms/edit-asset-basic (dissoc values :asset/company))]}])}
     [:i.fas.fa-edit]
     "Edit"]]
   [:div.profile-component__group
    [components/info-group-component id [{:label "name"
                                          :value name
                                          :icon "fas fa-balance-scale"}
                                         {:label "category"
                                          :value category
                                          :icon "fas fa-layer-group"}
                                         {:label "company"
                                          :value company
                                          :icon "fas fa-building"}
                                         {:label "address"
                                          :value location
                                          :icon "fas fa-address-book"}]]
    [asset-image-component name images]]])

(defn asset-scale-component
  [id {:keys [info-group cell-model name images scale] :as data}]
  (let [scale-map (first scale)]
    [:div.asset-scale-component.profile-component.component-card
     [:div.profile-component__head
      [:div [:h3 name]]
      [:div.head__icon
       {:on-click #(rf/dispatch [:modal {:show? true
                                         :title (str "Edit " name)
                                         :child [forms/form-component
                                                 (forms/edit-asset-scale
                                                  (assoc data :id id))]}])}
       [:i.fas.fa-edit]
       "Edit"]]
     [:div.profile-component__group
      [components/info-group-component id info-group]
      [asset-image-component name images]]
     (let [row-n (/ (count cell-model) 2)
           row-1 (take row-n cell-model)
           row-2 (drop row-n cell-model)]
       [:<>
        [:div.asset-scale-component__cells.gap-sm
         (for [{:keys [name]} row-1]
           ^{:key (str id name)}
           [scale-cell-box-static {:cell (get scale-map name)
                                   :model "RL0000"
                                   :sn "XXXXXXXXXX"}])]
        [:div.asset-scale-component__cells.asset-scale-component__cells--reverse.gap-sm
         (for [{:keys [name]} row-2]
           ^{:key (str id name)}
           [scale-cell-box-static {:cell (get scale-map name)
                                   :model "RL0000"
                                   :sn "XXXXXXXXXX"}])]])]))


(defn asset-component-box
  [id {:keys [name info-group images] :as data}]
  [:div.profile-component.profile-component-box.component-card
   [:div.profile-component__head
    [:div [:h3 name]]
    [:div.head__icon
     {:on-click #(rf/dispatch [:modal {:show? true
                                       :title (str "Edit " name)
                                       :child [forms/form-component
                                               (forms/edit-asset-component
                                                (assoc data :id id))]}])}
     [:i.fas.fa-edit]
     "Edit"]]
   [:div.profile-component__group
    [components/info-group-component id info-group]
    [asset-image-component name images]]])
